import { Grid } from '@mui/material'
import { Child } from '../../../../containers/common/child'
import { GItem } from '../grids'
import { UnitTitle } from './unitTitle'
import { OperationId } from '../../../../containers/common/constant/operationLog'
import { GetCategoryMstDto } from '../../../../dataAccess/webApi/dto/categoryMstDto'
import { memberModifyChildEatingUrl } from '../../../../containers/common/constant/appUrl'

export const CATEGORY_NAMES = ['howToNurse', 'howToNurseNote', 'babyFoodStartEnd', 'babyFoodStage','babyFoodShape','babyFoodRice','milk', 'favoriteFood', 'hatedFood', 'allergyFreeFood', 'eatingNote', 'eatingStyle']

interface ChildEatingUnitProps {
  child?: Child
  sectionLabel: string
  categoryMst?: GetCategoryMstDto[]
  hideLink?: boolean
}

export const ChildEatingUnit = (props: ChildEatingUnitProps) => {
  const { categoryMst, child, sectionLabel } = props
  if (child == null || categoryMst == null || categoryMst.length === 0) return null
  
  const targetCategories = categoryMst?.filter((value) => CATEGORY_NAMES.includes(value.category))
  if (targetCategories == null || targetCategories.length === 0) return null
  
  const childEating = child?.eating
  const hasEatingStyleData = childEating?.eatingStyle?.length
  
  const eatingFlag = hasEatingData(targetCategories, childEating?.eating) || hasEatingStyleData
  return (
    <>
      <UnitTitle title={sectionLabel} linkTo={memberModifyChildEatingUrl.url(child.childId)} operationLog={{ operationId: OperationId.OP_00000185 }} hideLink={props.hideLink} />
      <Grid container>
        <GItem xs={12}>{ eatingFlag ? '登録あり' : '登録なし'}</GItem>
      </Grid>
    </>
  )
}

const hasEatingData = (targetCategories: GetCategoryMstDto[], eating: any) => {
  if (eating == null) return false
  
  const targetCategoryNames = targetCategories.map(e => e.category)
  return targetCategoryNames.some(categoryName => eating[categoryName] != null && eating[categoryName] !== "")
}